export const updateZendeskWidgetSettings = ({ suppress = false, zIndex = 999999 } = {}) => {
    const settings = {
        zIndex,
        chat: {
            suppress,
        },
        contactForm: {
            suppress,
        },
        helpCenter: {
            suppress,
        },
        talk: {
            suppress,
        },
        answerBot: {
            suppress,
        },
    };

    if (typeof window.zE === "function") {
        // at run-time
        window.zE("webWidget", "updateSettings", {
            webWidget: settings,
        });
    } else {
        // not loaded yet
        window.zESettings = {
            webWidget: settings,
        };
    }
};
